module.exports = __webpack_public_path__ + "img/13.06bc7d23.jpg";